import { useState } from 'react'
import InputProgress from "react-input-progress"
import './App.css'

function App() {
  const maxLength = 15
  const [inputValue, setInputValue] = useState('')

  const onChange = (val) => {
    setInputValue(val)
  }

  return (
    <div className="App">
      <header className="App-header">
        <div className="App-content">
          <p>Maximum length: 15</p>
          <input
            type="text"
            value={inputValue}
            onChange={(evt) => onChange(evt.target.value)}
            maxLength={maxLength}
          />
          <InputProgress input={inputValue} maxLength={maxLength} />
        </div>
      </header>
    </div>
  )
}

export default App
